import React, { useState } from "react";
import {
  FlatList,
  Image,
  ImageBackground,
  SafeAreaView,
  ScrollView,
  Text,
  TouchableOpacity,
  View,
} from "react-native";
import CardFlip from "react-native-card-flip";
import {
  getMultimedia,
  getRecursText,
  getRecursURL,
} from "../../../Functions/getRecurs";
import globalstyle from "../../../Styles/Globals/globals";
import style from "../../../Styles/quizz";
import Menu from "../../menu";

function Quizz(RouterData) {
  const { poi, itinerari, recursos, projecte, idioma, currentItinerari } =
    RouterData.route.params;

  const poiData = itinerari.pois.find((e) => e.id === poi.id);
  const premi = projecte.premis.find((e) => e.id === poiData.premi);

  const cards = [];
  const [continuar, setContinuar] = useState(false);
  const [punts, setPunts] = useState(premi?.punts || 100);

  if (!premi) {
    alert("El poi no té premi!");
  }

  const flipCard = (index, valid) => {
    if (!continuar) {
      cards[index].flip({ duration: 700, flipDiretion: "y" });
      if (valid) {
        setContinuar(true);
      } else {
        setPunts(punts - 25);
      }
    }
  };

  return (
    <View style={{ flex: 1 }}>
      <ImageBackground
        source={{
          uri: getRecursURL(recursos, "background_default", idioma),
        }}
        style={style.backgroundImatges}
      >
        {/* Pregunta */}
        <View
          style={{
            flex: 40,
            justifyContent: "center",
            alignItems: "center",
            alignSelf: "center",
            width: "100%",
          }}
        >
          <View style={style.questionBackground}>
            <ScrollView
              contentContainerStyle={style.scroll}
              showsHorizontalScrollIndicator={false}
              showsVerticalScrollIndicator={false}
            >
              {poiData.imatgePopUpInicial?.url && (
                <Image
                  resizeMode="contain"
                  style={{ height: "80%" }}
                  source={{
                    uri: getMultimedia(poiData, "imatgePopUpInicial"),
                  }}
                />
              )}
              <View style={{ justifyContent: "center", alignItems: "center", marginTop: 10 }}>
                <Text style={style.question}>
                  {poiData[`Quizz${idioma}`].pregunta}
                </Text>
              </View>
            </ScrollView>
          </View>
        </View>
        {/* Respostes */}
        <View
          style={{ flex: 40, justifyContent: "center", alignItems: "center" }}
        >
          <SafeAreaView style={style.safeAreaAnswer}>
            <FlatList
              data={poiData["Quizz" + idioma].respostes}
              style={{ flex: 1 }}
              showsVerticalScrollIndicator={false}
              showsHorizontalScrollIndicator={false}
              renderItem={({ item, index }) => (
                <View
                  style={{
                    flexDirection: "column",
                    justifyContent: "center",
                    margin: 1,
                  }}
                >
                  <CardFlip
                    style={style.cardContainer}
                    ref={(card) => cards.push(card)}
                  >
                    <TouchableOpacity
                      style={style.containerAnswer}
                      onPress={() => {
                        flipCard(index, item.valid);
                      }}
                    >
                      {poiData.Tipus === "Quizz" ? (
                        <Text style={style.answer}>{item["answer"]}</Text>
                      ) : (
                        <Image
                          resizeMode="contain"
                          style={style.questionImage}
                          source={{
                            uri: getMultimedia(
                              poiData,
                              `resposta_imatge_${item.id}`,
                            ),
                          }}
                        />
                      )}
                    </TouchableOpacity>
                    <TouchableOpacity style={style.containerAnswerBack}>
                      <Image
                        resizeMode="contain"
                        style={style.solucio}
                        source={{
                          uri: getRecursURL(
                            recursos,
                            item.valid ? "resposta_encert" : "resposta_error",
                            idioma,
                          ),
                        }}
                      />
                    </TouchableOpacity>
                  </CardFlip>
                </View>
              )}
              numColumns={2}
              keyExtractor={(item, index) => index}
            />
          </SafeAreaView>
        </View>

        <View style={{ flex: 10, justifyContent: "center" }}>
          {continuar ? (
            <TouchableOpacity
              onPress={() => {
                currentItinerari.pois.find((e) => e.id === poi.id).punts =
                  punts;
                RouterData.navigation.navigate(
                  "Premi",
                  RouterData.route.params,
                );
              }}
            >
              <Text style={globalstyle.botoContinuar}>
                {getRecursText(recursos, "text_continuar", idioma)}
              </Text>
            </TouchableOpacity>
          ) : null}
        </View>
        <View style={{ flex: 10 }}><Menu projecte={RouterData.route.params}></Menu></View>
      </ImageBackground>
    </View>
  );
}

export default Quizz;
